exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".standard-list[data-v-4519a8c7] ul{margin-top:1rem;margin-bottom:1.5rem}[data-v-4519a8c7] .standard-list div>br:last-child{display:unset}@media(max-width:600px){.itinerary-detail-button[data-v-4519a8c7]{height:48px;width:100%}}", ""]);

// exports
